module.exports = __webpack_public_path__ + "img/consult_info3.5a014394.png";